<template>
  <div>
    <div class="bottom">
      <div class="bottom_contation">
        <div class="contation1">
          <p>快速导航</p>
          <p @click="routerPage('', '/home')">
            <img
              class="icon_lingxing"
              src="@/assets/logo/lingxing.png"
              alt=""
            >
            <span>首页</span>
          </p>
          <p @click="routerPage('#anchor6')">
            <img
              class="icon_lingxing"
              src="@/assets/logo/lingxing.png"
              alt=""
            >
            <span>安全产品</span>
          </p>
          <p @click="routerPage('#anchor1')">
            <img
              class="icon_lingxing"
              src="@/assets/logo/lingxing.png"
              alt=""
            >
            <span>安全服务</span>
          </p>
          <p @click="routerPage('#anchor2')">
            <img
              class="icon_lingxing"
              src="@/assets/logo/lingxing.png"
              alt=""
            >
            <span>应用场景及技术解决方案</span>
          </p>
          <p
            class="con"
            @click="routerPage('', '/synopsis')"
          >
            <img
              class="icon_lingxing"
              src="@/assets/logo/lingxing.png"
              alt=""
            >
            <span>关于我们</span>
          </p>
        </div>
        <div class="contation2">
          <p>联系方式</p>
          <p>
            <img
              class="icon_lingxing"
              src="@/assets/logo/lingxing.png"
              alt=""
            >
            <span>联系电话：0371-55332258</span>
          </p>
          <p>
            <img
              class="icon_lingxing"
              src="@/assets/logo/lingxing.png"
              alt=""
            >
            <span>联系地址：郑州市金水区国基路60号国家知识产权创意产业试点园区A座4楼409室</span>
          </p>
        </div>
        <div class="contation3">
          <img
            src="@/assets/home/gzh.png"
            alt=""
          >
          <p>公司公众号</p>
        </div>
      </div>
    </div>
    <div class="filing_fo">
      <a
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
      >
        ©2022 豫ICP备2022028071号-1
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() { },
  methods: {
    routerPage(anchor, url) {
      if (anchor) {
        this.$emit('routerPage', anchor)
        sessionStorage.setItem('activeIndex', '1')
      } else {
        if (url === '/home') {
          this.$router.push(url)
          sessionStorage.setItem('activeIndex', '1')
        } else {
          this.$router.push(url)
          sessionStorage.setItem('activeIndex', '5')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.bottom {
  width: 100%;
  background: linear-gradient(to top, #143274, #194280);
  color: #fff;
  padding: 100px 0;
  min-width: 1200;

  .bottom_item {
    padding: 10px 0;
    text-align: center;
    background: #000;
    opacity: 0.5;
    font-size: 14px;

    div {
      line-height: 22px;
    }
  }

  .bottom_contation {
    width: 70%;
    margin: 0 auto;
    padding: 15px 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .contation1 {
      font-size: 16px;

      p:nth-child(1) {
        cursor: auto;
        font-size: 20px;
      }

      p {
        display: flex;
        align-items: center;
        cursor: pointer;

        span:nth-child(2) {
          margin-left: 5px;
        }
      }

      p:hover {
        color: #2d71f6;
      }
    }

    .contation2 {
      font-size: 16px;

      p:nth-child(1) {
        font-size: 20px;
      }

      p {
        line-height: 28px;

        span:nth-child(2) {
          margin-left: 5px;
        }
      }
    }

    .contation3 {
      img {
        margin-top: 5px;
        width: 138px;
        height: auto;
      }

      p {
        font-size: 16px;
        text-align: center;
      }
    }
  }

  .diamond {
    width: 14px;
    margin-right: 5px;
  }
}

.filing_fo {
  text-align: center;
  cursor: pointer;
  padding: 10px 0;
  font-size: 16px;

  a {
    text-decoration: none;
  }

  a:hover {
    color: #551a8b;
  }
}

.icon_lingxing {
  width: 14px;
  height: auto;
}
</style>
